var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgColor = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3997"
    },
    d: "M501.799,275.95c-2.098-4.801-4.499-9.3-7.2-13.801L391,67.45L288.701,261.849 C277,280.749,271,302.35,271,324.55c0,66.299,53.699,120,120,120s121-53.701,121-120C512,307.75,508.4,291.251,501.799,275.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F50B75"
    },
    d: "M512,324.55c0,66.299-54.699,120-121,120V67.45l103.599,194.7c2.701,4.501,5.101,9,7.2,13.801 C508.4,291.251,512,307.75,512,324.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD400"
    },
    d: "M365.799,275.95c-2.098-4.801-4.499-9.3-7.2-13.801L256,67.45L153.701,261.849 C142,280.749,136,302.35,136,324.55c0,66.299,53.699,120,120,120s120-53.701,120-120C376,307.75,372.4,291.251,365.799,275.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBF00"
    },
    d: "M376,324.55c0,66.299-53.699,120-120,120V67.45l102.599,194.7c2.701,4.501,5.101,9,7.2,13.801 C372.4,291.251,376,307.75,376,324.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#25D9F8"
    },
    d: "M230.799,275.95c-2.098-4.801-4.499-9.3-7.2-13.801L121,67.45L17.701,261.849 C6,280.749,0,302.35,0,324.55c0,66.299,54.699,120,121,120s120-53.701,120-120C241,307.75,237.4,291.251,230.799,275.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C0F1"
    },
    d: "M241,324.55c0,66.299-53.699,120-120,120V67.45l102.599,194.7c2.701,4.501,5.101,9,7.2,13.801 C237.4,291.251,241,307.75,241,324.55z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/color.54eb2c05.svg";
export { ForwardRef as ReactComponent };